export default {
    Started: 'started',
    Establishing: 'establishing',
    Established: 'established',
    MeetingStarted: 'meetingStarted',
    Inviting: 'inviting',
    Invited: 'invited',
    TranscriptStarting: 'transcriptStarting',
    TranscriptStarted: 'transcriptStarted',
    ParticipantJoined: 'participantJoined',
    Deleting: 'deleting',
    Deleted: 'deleted',
    InitialTranscriptStreamed: 'initialTranscriptStreamed',
    MeetingEnded: 'meetingEnded',
    Ending: 'ending',
    Ended: 'ended',
    RecordingSuccess: 'recordingSuccess',
};
